// CREATE ELEMENT FOR PHOTOSWIPER PLUGIN(GALLERY)
let blockAdminContent = document.querySelector(".block_admin_content");
if (blockAdminContent !== null) {
  let arrImgs = blockAdminContent.querySelectorAll("img");
  for (let img of arrImgs) {
    let linkEl = document.createElement("a");
    linkEl.setAttribute("style", img.getAttribute("style"));
    linkEl.setAttribute("href", img.getAttribute("src"));
    linkEl.setAttribute("data-size", getSizeImg(img));
    let newImgEl = img.cloneNode(true);
    // newImgEl.classList.add("img-responsive");
    linkEl.appendChild(newImgEl);
    img.parentNode.replaceChild(linkEl, img);
  }
}
function getSizeImg(imgSrc) {
  let width = imgSrc.naturalWidth;
  let height = imgSrc.naturalHeight;
  return width + "x" + height;
}
// CREATE ELEMENT FOR PHOTOSWIPER PLUGIN(GALLERY)
let blockContent = document.querySelector(".gallery");
(function () {
  var initPhotoSwipeFromDOM = function (gallerySelector) {
    var parseThumbnailElements = function (el) {
      var thumbElements = [];
      for (let el of blockContent.querySelectorAll("a")) {
        if (el.getAttribute("data-size") !== null) {
          thumbElements.push(el);
        }
      }
      // var thumbElements = el.childNodes,
      // var thumbElements = blockContent.querySelectorAll("a");
      var numNodes = thumbElements.length,
        items = [],
        el,
        childElements,
        thumbnailEl,
        size,
        item;
      for (var i = 0; i < numNodes; i++) {
        el = thumbElements[i];
        // include only element nodes
        if (el.nodeType !== 1) {
          continue;
        }

        childElements = el.children;
        size = el.getAttribute("data-size").split("x");
        // create slide object
        item = {
          src: el.getAttribute("href"),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
          // author: el.getAttribute("data-author"),
          // title: el.getAttribute("data-title"),
        };

        item.el = el; // save link to element for getThumbBoundsFn

        if (childElements.length > 0) {
          item.msrc = childElements[0].getAttribute("src"); // thumbnail url
          if (childElements.length > 1) {
            item.title = childElements[1].innerHTML; // caption (contents of figure)
          }
        }

        var mediumSrc = el.getAttribute("data-med");
        if (mediumSrc) {
          size = el.getAttribute("data-med-size").split("x");
          // "medium-sized" image
          item.m = {
            src: mediumSrc,
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10),
          };
        }
        // original image
        item.o = {
          src: item.src,
          w: item.w,
          h: item.h,
        };

        items.push(item);
      }

      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    var onThumbnailsClick = function (e) {
      let elClick = e.target;
      if (elClick.closest("a") !== null) {
        if (elClick.closest("a").getAttribute("data-size") === null) {
          return;
        }
      }
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);

      var eTarget = e.target || e.srcElement;

      var clickedListItem = closest(eTarget, function (el) {
        return el.tagName === "A";
      });
      if (!clickedListItem) {
        return;
      }

      // var clickedGallery = clickedListItem.parentNode;
      var clickedGallery = clickedListItem.closest(".gallery");
      // var childNodes = clickedListItem.parentNode.childNodes,
      // var childNodes = blockContent.querySelectorAll("a");
      var childNodes = [];
      for (let el of blockContent.querySelectorAll("a")) {
        if (el.getAttribute("data-size") !== null) {
          childNodes.push(el);
        }
      }
      var numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue;
        }

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if (index >= 0) {
        openPhotoSwipe(index, clickedGallery);
      }
      return false;
    };

    var photoswipeParseHash = function () {
      var hash = window.location.hash.substring(1),
        params = {};

      if (hash.length < 5) {
        // pid=1
        return params;
      }

      var vars = hash.split("&");
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        var pair = vars[i].split("=");
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };

    var openPhotoSwipe = function (
      index,
      galleryElement,
      disableAnimation,
      fromURL
    ) {
      var pswpElement = document.querySelectorAll(".pswp")[0],
        gallery,
        options,
        items;

      items = parseThumbnailElements(galleryElement);
      // define options (if needed)
      options = {
        galleryUID: galleryElement.getAttribute("data-pswp-uid"),

        getThumbBoundsFn: function (index) {
          // See Options->getThumbBoundsFn section of docs for more info
          var thumbnail = items[index].el.children[0],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },

        addCaptionHTMLFn: function (item, captionEl, isFake) {
          if (!item.title) {
            captionEl.children[0].innerText = "";
            return false;
          }
          // captionEl.children[0].innerHTML =
          //   item.title + "<br/><small>Photo: " + item.author + "</small>";
          return true;
        },
      };

      if (fromURL) {
        if (options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      // exit if index not found
      if (isNaN(options.index)) {
        return;
      }

      var radios = document.getElementsByName("gallery-style");
      for (var i = 0, length = radios.length; i < length; i++) {
        if (radios[i].checked) {
          if (radios[i].id == "radio-all-controls") {
          } else if (radios[i].id == "radio-minimal-black") {
            options.mainClass = "pswp--minimal--dark";
            options.barsSize = { top: 0, bottom: 0 };
            options.captionEl = false;
            options.fullscreenEl = false;
            options.shareEl = false;
            options.bgOpacity = 0.85;
            options.tapToClose = true;
            options.tapToToggleControls = false;
          }
          break;
        }
      }

      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }

      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );

      // see: http://photoswipe.com/documentation/responsive-images.html
      var realViewportWidth,
        useLargeImages = false,
        firstResize = true,
        imageSrcWillChange;

      gallery.listen("beforeResize", function () {
        var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
        dpiRatio = Math.min(dpiRatio, 2.5);
        realViewportWidth = gallery.viewportSize.x * dpiRatio;

        if (
          realViewportWidth >= 1200 ||
          (!gallery.likelyTouchDevice && realViewportWidth > 800) ||
          screen.width > 1200
        ) {
          if (!useLargeImages) {
            useLargeImages = true;
            imageSrcWillChange = true;
          }
        } else {
          if (useLargeImages) {
            useLargeImages = false;
            imageSrcWillChange = true;
          }
        }

        if (imageSrcWillChange && !firstResize) {
          gallery.invalidateCurrItems();
        }

        if (firstResize) {
          firstResize = false;
        }

        imageSrcWillChange = false;
      });

      gallery.listen("gettingData", function (index, item) {
        // if (useLargeImages) {
        item.src = item.o.src;
        item.w = item.o.w;
        item.h = item.o.h;
        // } else {
        //   item.src = item.m.src;
        //   item.w = item.m.w;
        //   item.h = item.m.h;
        // }
      });

      gallery.init();
    };

    // select all gallery elements
    var galleryElements = document.querySelectorAll(gallerySelector);
    // console.log(gallerySelector);
    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute("data-pswp-uid", i + 1);
      galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(
        hashData.pid,
        galleryElements[hashData.gid - 1],
        true,
        true
      );
    }
  };

  initPhotoSwipeFromDOM(".gallery");
})();

// BTN LOAD MORE
let offsetGallery;
let containerForBtn = document.querySelector(".container_gallery_btn");
let btnGalleryLoadMore = document.getElementById("btn_load_more");

if (typeof btnGalleryLoadMore != "undefined" && btnGalleryLoadMore != null) {
  btnGalleryLoadMore.addEventListener("click", function () {
    offsetGallery = btnGalleryLoadMore.getAttribute("data-offset");
    console.log("get offset btn", offsetGallery);
    getImgs(offsetGallery);
  });
}

function getImgs(offset) {
  const request = new XMLHttpRequest();
  const url = "/gallery/load-more";
  const params = "offset=" + offset + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log(request.responseText);
        let response = JSON.parse(request.responseText);
        processResponseGallery(response.images);
        if (
          response.showLoadMore === false ||
          response.showLoadMore === "false"
        ) {
          containerForBtn.classList.add("hide");
        } else {
          console.log("get offset response", response.offset);
          btnGalleryLoadMore.setAttribute("data-offset", response.offset);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function processResponseGallery(response) {
  console.log(response);
  for (let item in response) {
    createHtmlForGallery(
      response[item].image,
      response[item].image_compressed,
      response[item].size
    );
  }
}

function createHtmlForGallery(img, img_compressed, size) {
  let htmlForGallery =
    `
<a
class="gallery__item"
href="` +
    img +
    `"
data-size="` +
    size +
    `"
>
<img
  src="` +
    img_compressed +
    `"
  class="img-responsive"
/>
<figure class="gallery__figure">
  <figcaption class="gallery__figcaption">
  </figcaption>
</figure>
</a>
`;

  let mainGalleryTag = document.getElementById("main_gallery");
  mainGalleryTag.insertAdjacentHTML("beforeend", htmlForGallery);
}

// block gallery msg
const blockOkGalleryMsg = document.querySelector(".block_gallery_top_msg");
const btnOkGalleryMsg = document.querySelector(".btn_gallery_top_msg");

btnOkGalleryMsg && btnOkGalleryMsg.addEventListener("click", function () {
  blockOkGalleryMsg.style.display = "none";
});

setTimeout(()=> {
  if(blockOkGalleryMsg) {
    blockOkGalleryMsg.style.display = "none";
  }
}, 10000);